import React from 'react';
import { styled } from '@mui/material/styles';

const sizeMap = {
  sm: '36px',
  md: '40px',
  lg: '48px',
};

const FooterIconButton = styled('a')(
  ({  size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => ({
    width: sizeMap[size],
    height: sizeMap[size],
    borderRadius: '50rem',
    background: 'linear-gradient(rgba(10, 98, 116, 0), rgba(10, 98, 116, 0.2))',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
    position: 'relative',
    border: 'none',
    cursor: 'pointer',
    zIndex: 1,
    padding: 0,

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      padding: '1px',
      borderRadius: '50rem',
      background:
        'linear-gradient(90deg,rgba(0, 138, 138, 0.5), rgba(10, 98, 116, 0))',
      WebkitMask:
        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      zIndex: -1,
      transition: 'opacity 0.3s ease',
    },

    '&:hover': {
      boxShadow:
        '0px -1px 3px rgba(0, 138, 138, 0.3), 0px 2px 10px rgba(0,0,0,0.5)',
      background:
        'linear-gradient(0deg, rgba(10, 98, 116, 0.5), rgba(10, 98, 116, 0.0))',
      '&::before': {
        background:
          'linear-gradient(90deg,rgba(0, 138, 138, 1), rgba(10, 98, 116, 0))',
      },
    },

    '&:active':{
                boxShadow:
                  '0px -1px 3px rgba(0, 138, 138, 0.6), 0px 2px 10px rgba(0, 138, 138, 0.3)',
                  background:
                  'linear-gradient(0deg, rgba(10, 98, 116, 0.5), rgba(10, 98, 116, 0.8))',
                  '&::before': {
                  background: 'linear-gradient(90deg,rgba(0, 138, 138, 1), rgba(10, 98, 116, 0.8))',
                  boxShadow:
                  '0px -1px 3px rgba(0,0,0, 0.3), 0px 2px 10px rgba(0,0,0,0.5)',
                },
              }
  })
);

type FooterIconButtonProps = {
  icon: React.ReactNode;
  href: string;
  size?: 'sm' | 'md' | 'lg';
};

const FooterIconButtonComponent: React.FC<FooterIconButtonProps> = ({
  icon,
  href,
  size = 'md',
}) => {
  return (
    <FooterIconButton href={href} target="_blank" rel="noopener noreferrer" size={size}>
      {icon}
    </FooterIconButton>
  );
};

export default FooterIconButtonComponent;
